export const SET_USERNAME = 'set_username';

const state = () => ({
  username: null,
});

const actions = {};

const mutations = {
  [SET_USERNAME] (state, username) {
    state.username = username;
  },
};

const getters = {};

export default {
  state,
  mutations,
  actions,
  getters,
};
